import axios from 'axios'
import endpoints from '@/api/endpoints'

export default {
  async getDivisions () {
    return axios.get(endpoints.divisions).then((response) => {
      return response.data
    })
  },
  async getApps () {
    return axios.get(endpoints.apps).then((response) => {
      return response.data
    })
  },
  async getDivision (id) {
    return axios.get(endpoints.divisions + id + '/').then((response) => {
      return response.data
    })
  },
  async updateDivision (div) {
    return axios.patch(endpoints.divisions + div.id + '/', div).then((response) => {
      return response.data
    })
  },
  async getGlobalOptions () {
    return axios.get(endpoints.globalOptions).then((response) => {
      return response.data
    })
  },
  async getSettings () {
    // Hard coding a 1 since there should only be a single Settings record
    return axios.get(endpoints.settings).then((response) => {
      return response.data[0]
    })
  },
  async updateSettings (settings) {
    // Hard coding a 1 since there should only be a single Settings record
    return axios.patch(endpoints.settings + settings.id + '/', settings).then((response) => {
      return response.data
    })
  },
  async getNextJobNumber () {
    return axios.get(endpoints.getNextJobNumber).then((response) => {
      return response.data
    })
  },
  async getNextDocNumber () {
    // Returns a number per client's formatting
    return axios.get(endpoints.getNextDocNumber).then((response) => {
      return response.data
    })
  },
  async getActionTrackersFor (filter) {
    // the `filter` must be the API filter to apply. Such as `?estimate=123`
    return axios.get(endpoints.actionTracker + filter).then((response) => {
      return response.data
    })
  },
  async createActionTracker (act) {
    // act: a dictionary with the following fields:
    //
    // taken_by: profile ID of person creating the action
    // description: what they did
    // estimate: ID of the estimate <--- only for estimate actions
    // invoice: ID of the invoice <--- only for invoice actions
    return axios.post(endpoints.actionTracker, act).then((response) => {
      return response.data
    })
  },
  async updateActionTracker (act) {
    return axios.patch(endpoints.actionTracker + act.id + '/', act).then((response) => {
      return response.data
    })
  },

  // WO Types
  async getWOTypes () {
    return axios.get(endpoints.woTypes).then((response) => {
      return response.data
    })
  },
  async getWOTypesForDivision (obj) {
    return axios.get(endpoints.woTypes + '?division=' + obj.id).then((response) => {
      return response.data
    })
  },
  async createWOType (obj) {
    return axios.post(endpoints.woTypes, obj).then((response) => {
      return response.data
    })
  },
  async updateWOType (obj) {
    return axios.patch(endpoints.woTypes + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },

  // Driveway Ratings
  async getDrivewayRatings () {
    return axios.get(endpoints.drivewayRatings).then((response) => {
      return response.data
    })
  },
  async createDrivewayRating (obj) {
    return axios.post(endpoints.drivewayRatings, obj).then((response) => {
      return response.data
    })
  },
  async updateDrivewayRating (obj) {
    return axios.patch(endpoints.drivewayRatings + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  // Lot Size Ratings for Lawn
  async getRatings () {
    return axios.get(endpoints.ratings).then((response) => {
      return response.data
    })
  },
  async createRating (obj) {
    return axios.post(endpoints.ratings, obj).then((response) => {
      return response.data
    })
  },
  async updateRating (obj) {
    return axios.patch(endpoints.ratings + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
}
